"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_redux_1 = require("react-redux");

exports.useNotifications = function () {
  return react_redux_1.useSelector(function (store) {
    return store.notificationState.notifications;
  });
};